import {
  BookOpen,
  MessageCircle,
  FileText,
  Heart as HeartIcon,
  type LucideIcon,
} from 'lucide-react';
import type { FavoriteFilterType } from '@/types/favorites';

interface FavoritesFiltersProps {
  activeFilter: FavoriteFilterType;
  onFilterChange: (filter: FavoriteFilterType) => void;
  counts: {
    all: number;
    resource: number;
    message: number;
    file: number;
    prayer: number;
    verse: number;
  };
}

interface FilterTab {
  id: FavoriteFilterType;
  label: string;
  icon: LucideIcon;
}

const FILTER_TABS: FilterTab[] = [
  { id: 'all', label: 'All', icon: HeartIcon },
  { id: 'resource', label: 'Resources', icon: BookOpen },
  { id: 'message', label: 'Posts', icon: MessageCircle },
  { id: 'file', label: 'Materials', icon: FileText },
  { id: 'prayer', label: 'Prayers', icon: HeartIcon },
  { id: 'verse', label: 'Verses', icon: BookOpen },
];

export function FavoritesFilters({ activeFilter, onFilterChange, counts }: FavoritesFiltersProps) {
  return (
    <div className="px-4 py-2 border-b border-slate-100 overflow-x-auto">
      <div className="flex gap-2 min-w-max">
        {FILTER_TABS.map((tab) => {
          const Icon = tab.icon;
          const count = counts[tab.id];
          const isActive = activeFilter === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onFilterChange(tab.id)}
              className={`
                flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium
                transition-all whitespace-nowrap
                ${
                  isActive
                    ? 'bg-[#8e4585] text-white'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }
              `}
            >
              <Icon size={14} className={isActive ? 'text-white' : 'text-slate-500'} />
              <span>{tab.label}</span>
              {count > 0 && (
                <span
                  className={`
                    text-xs px-1.5 py-0.5 rounded-full min-w-[20px] text-center
                    ${isActive ? 'bg-white/20 text-white' : 'bg-slate-200 text-slate-500'}
                  `}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
